import { Injectable, signal } from '@angular/core';
import { BehaviorSubject } from 'rxjs';


@Injectable({
  providedIn: 'root',
})
export class SignalsService {
  constructor() {}

  //Loading Modal
  isLoading$ = signal<boolean>(false);
  
  //Setting change update 
  settingsChanged$ = signal<boolean>(false);

  // Sets the default tab item, Flight Table or Flight Calendar
  defaultTabItem$ = signal<number>(0);

  //Employee Number changes 
  _empNumberObs = new BehaviorSubject<string>('')
  employeeNumber$ = this._empNumberObs.asObservable();
  // get empNumber(): string {
  //   return this._empNumberObs.getValue();
  // }



  //Admin
  _authEmployeeNumber = new BehaviorSubject<string>('');
  authEmployeeNumber$ = this._authEmployeeNumber.asObservable();

  isEumulatingEmpNumActive$ = signal<boolean>(false); //Admin status

  //Admin Role Authorization Setting
  _isAdminRole$ = new BehaviorSubject<boolean>(false);
  isAdminRole$ = this._isAdminRole$.asObservable();

}
